import { Switch, RouteComponentProps, Redirect } from 'react-router'
import AuthenticatedView from '@/authenticated-view'

import { FormProvider } from './form-context'
import ListingCreate from './listing-create'
import ListingDetails from './listing-details'
import ListingMedia from './listing-media'
import ListingSummary from './listing-summary'
import ListingEdit from './listing-edit'

const CreateListingWizard = () => {
  return (
    <FormProvider>
      <Switch>
        <AuthenticatedView
          exact
          path="/listing/create/:listingId"
          render={({ match }: RouteComponentProps<{ listingId: string }>) => (
            <Redirect to={`/listing/create/${match.params.listingId}/details/`} />
          )}
        />
        <AuthenticatedView
          exact
          path="/listing/create/:listingId/location/"
          component={ListingCreate}
          allowTo={['landlord']}
        />
        <AuthenticatedView
          exact
          path="/listing/create/:listingId/details/"
          component={ListingDetails}
          allowTo={['landlord']}
        />
        <AuthenticatedView
          exact
          path="/listing/create/:listingId/media/"
          component={ListingMedia}
          allowTo={['landlord']}
        />
        <AuthenticatedView
          exact
          path="/listing/create/:listingId/summary/"
          component={ListingSummary}
          allowTo={['landlord']}
        />
        <AuthenticatedView
          exact
          path="/listing/create/"
          component={ListingCreate}
          allowTo={['landlord']}
        />
        <AuthenticatedView
          exact
          path="/listing/edit/:listingId"
          component={ListingEdit}
          allowTo={['landlord']}
        />
      </Switch>
    </FormProvider>
  )
}

export default CreateListingWizard
